import Dexie from 'dexie';
import { DBConfig, storeSchema } from './IndexDBConfig';

export const db = new Dexie(DBConfig.name);
db.version(DBConfig.version).stores({
    audios: `${storeSchema.indexes.map((i) => i.keyPath).join(', ')}`,
});
